export default __webpack_public_path__ + "static/media/vp.dc6eadd6.svg";